/* eslint new-cap: [2, { "capIsNewExceptions": ["Map"] }] */
/* eslint react/jsx-filename-extension: 0 */

import { DefaultDraftBlockRenderMap } from 'draft-js';
import { Map } from 'immutable';

const blockRenderMapGenerator = () => {
    const blockRenderMap = Map({
        hr: { element: 'div' },
        // we're actually rendering the header with id in the blockrenderer,
        // this is a limitation caused by certain behaviour in draft-js. If we
        // supply a custom element to this object, we can not switch focus between
        // root and nested editor
        'header-one': { element: 'div' },
        'header-two': { element: 'div' },
        'header-three': { element: 'div' },
        callout: { element: 'figure' },
    });

    return DefaultDraftBlockRenderMap.merge(blockRenderMap);
};

export default blockRenderMapGenerator;
